<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import Card from '@/components/Card.vue';
import { useAuthStore } from '@/stores/auth';
import { useGlobalStore } from '@/stores/global';
import { useModuleStore } from '@/stores/module';
import type { Module } from '@/types/module';

const route = useRoute();
const currentModule = ref<Module | null>();

const isInitializing = ref<boolean>(true);
const moduleStore = useModuleStore();
const globalStore = useGlobalStore();
const authStore = useAuthStore();

onMounted(async () => {
    currentModule.value = await moduleStore.fetchByName(route.params.module.toString());
    isInitializing.value = false;
});

watch(
    () => route.params.module.toString(),
    async (newValue, oldValue) => {
        if (newValue != oldValue && oldValue != undefined) {
            currentModule.value = await moduleStore.fetchByName(newValue);
        }
    }
);
</script>

<!-- TODO: fetch modules per organization here. Since the purchased modules can differ per organization. -->
<template>
    <v-fade-transition>
        <div v-show="!isInitializing && !globalStore.isLoading">
            <template v-if="currentModule">
                <v-row class="ga-lg-0 justify-center justify-lg-start">
                    <Card
                        name="Documenten"
                        imageUrl="/images/documents.svg"
                        :route="`/documenten/${currentModule.name}`"
                        :text="`Hierin staan alle documenten voor de ${currentModule.name} module`"
                    />

                    <Card
                        v-if="currentModule.name == 'RI&E' && authStore.isSecurityOfficer"
                        name="Vragenlijst sjablonen"
                        imageUrl="/images/module-blocks/rie.svg"
                        route="/modules/rie/vragenlijst-sjablonen/"
                        text="Beheer de RI&E-vragenlijst sjablonen voor uw organisatie"
                    />
                </v-row>
            </template>
            <template v-else>
                <p>Deze module bestaat niet.</p>
            </template>
        </div>
    </v-fade-transition>
</template>

<style scoped></style>
